module.exports = __webpack_public_path__ + "img/SES_205251400.1a5f1bbe.jpg";